/**
 * YTB 独立构建 router — 仅 /ytb 路由树，不引入 app / dmg / sccp 页面
 *
 * 路由定义见 routes/corp/ytb.js；由 main-ytb.ts 引用本文件
 */
import { createRouter, createWebHistory } from "vue-router";
import { useThemeStore } from "@/stores/modules/theme.store";
import { initYtbStandaloneBranding, syncDocumentBranding } from "@/views/corp/ytb/lib/ytb-document-branding.js";
import { ytbRoutesForStandalone } from "./routes/corp/ytb";

const router = createRouter({
  history: createWebHistory(),
  routes: ytbRoutesForStandalone,
});

router.beforeEach((to, _from, next) => {
  next();
  useThemeStore().setRouteTypeByPath(to.path);
});

initYtbStandaloneBranding();

router.afterEach((to) => {
  syncDocumentBranding(to);
});

export default router;
